import React, { useState, useEffect } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import {
  StyledAppBar,
  StyledContainer,
  StyledToolbar,
  StyledIconButton,
  StyledMenu,
  StyledMenuItem,
  StyledButton,
  StyledBox,
  Logo
} from './styles';
import MedicheckLogo from '../../assets/MedicheckLogo.png';

const pages = ['Home', 'About', 'Features', 'Pricing', 'Contact'];

const Navbar = () => {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleScrollToSection = (page) => {
    const sectionId = page.toLowerCase().replace(/\s+/g, '');
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
    handleCloseNavMenu();
  };

  useEffect(() => {
    const handleScroll = () => {
      // If scrolled more than 0px, set scrolled to true
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    // Cleanup event listener on unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <StyledAppBar
      position="fixed"
      sx={{
        background: scrolled ? 'rgba(255, 255, 255, 0.95)' : 'transparent',
        boxShadow: scrolled ? '0px 2px 6px rgba(0, 0, 0, 0.15)' : 'none',
        transition: 'background 0.5s ease, boxShadow 0.5s ease',
      }}
    >
      <StyledContainer maxWidth="xl">
        <StyledToolbar disableGutters>
          {/* Desktop Logo */}
          <Logo
            noWrap
            // component="a"
            // href="/"
            sx={{ display: { xs: 'none', md: 'flex' } }}
          >
            <img
              src={MedicheckLogo}
              alt="Medicheck Logo"
              style={{ height: '50px', width: 'auto', cursor:'pointer' }}
              onClick={() => handleScrollToSection('home')}
            />
          </Logo>

           {/* Mobile Logo */}
           <Logo
            variant="h5"
            noWrap
            // component="a"
            // href="/"
            sx={{
              display: { xs: 'flex', md: 'none', margin:'auto' },
              flexGrow: 1,
            }}
          >
            <img
              src={MedicheckLogo}
              alt="Medicheck Logo"
              style={{ height: '50px', width: 'auto', cursor:'pointer' }}
              onClick={() => handleScrollToSection('home')}
            />
          </Logo>

          {/* Mobile Menu Icon */}
          <StyledBox sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }}>
            <StyledIconButton
              size="large"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </StyledIconButton>
          </StyledBox>

         

          {/* Desktop Nav Links */}
          <StyledBox
            sx={{
              flexGrow: 1,
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'flex-end',
            }}
          >
            {pages.map((page) => (
              <StyledButton
                key={page}
                onClick={() => handleScrollToSection(page)}
              >
                {page}
              </StyledButton>
            ))}
          </StyledBox>
        </StyledToolbar>
      </StyledContainer>

      {/* Mobile Menu */}
      <StyledMenu
        anchorEl={anchorElNav}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        open={Boolean(anchorElNav)}
        onClose={handleCloseNavMenu}
        sx={{ display: { xs: 'block', md: 'none' } }}
      >
        {pages.map((page) => (
          <StyledMenuItem
            key={page}
            onClick={() => handleScrollToSection(page)}
          >
            {page}
          </StyledMenuItem>
        ))}
      </StyledMenu>
    </StyledAppBar>
  );
};

export default Navbar;
